<script module lang="ts">
  import type { DropdownPoints } from '../components/dropdown/dropdown.types';
</script>

<script lang="ts">
  import { CommonTexts } from '../services/CommonTexts';
  import * as Icons from '@lucide/svelte';
  import Dropdown from '../components/dropdown/Dropdown.svelte';
  import { ModeService } from '../services/ModeService.svelte';
  import { MenuService } from '../services/MenuService.svelte';

  function useMode(toLight: boolean): void {
    ModeService.setMode(toLight ? 'light' : 'dark');
  }

  const MenuPoints: DropdownPoints = $derived(MenuService.menuSettings);
  const HasUserPoints = $derived(Object.keys(MenuPoints).length > 0);
  const SettingsPoints: DropdownPoints = $derived({
    ...MenuPoints,
    toLightMode: {
      label: CommonTexts.LightMode,
      icon: Icons.Sun,
      separated: HasUserPoints,
      active: ModeService.isMode('light'),
      onselect: () => {
        useMode(true);
      },
    },
    toDarkMode: {
      label: CommonTexts.DarkMode,
      icon: Icons.Moon,
      active: ModeService.isMode('dark'),
      onselect: () => {
        useMode(false);
      },
    },
  });
</script>

<aside class="LayoutSettings">
  <Dropdown icon="settings" label={CommonTexts.SettingsOpen} points={SettingsPoints} />
</aside>
